import { gql } from "@apollo/client";

export const GET_PROFILE = gql`
  query ProfileType {
    profile {
      id
      firstName
      lastName
      email
      PhoneAreaCode
      PhoneNumber
      isStaff
      isActive
      dateJoined
      avatar
      gender
      birthDate
      country
      city
      currency
      lastLogin
    }
  }
`;

export const SOCIAL_AUTH_PROVIDERS = gql`
  query SocialAuthProviders {
    socialAuthProviders {
      provider
      clientId
      sdkVersion
    }
  }
`;

export const GET_PREFERRED_LANGUAGE = gql`
  query GetPreferredLanguage {
    profile {
      preferredLanguage
    }
  }
`;

export const GET_LOYALTY_COUNTRIES_WITH_AREAS = gql`
  query LoyaltyCountriesWithAreas($language: String) {
    loyaltyCountriesWithAreas(language: $language) {
      available
      errorCode
      countries {
        ...ProfileLocationCountry
      }
    }
  }

  fragment ProfileLocationCountry on LoyaltyCountryType {
    countryId
    name
    areas {
      areaId
      name
    }
  }
`;
